/* ==========================================================================
   Meru House — product card add-to-bag

   The card's size chips and Add to bag button are plain submit buttons inside
   a normal /cart/add form, so the card still works with JavaScript disabled
   (it posts and lands on the cart page). This progressively enhances that
   into an AJAX add that refreshes and opens the cart drawer.

   Also wires up the persistent quick-add bag button:
     - single-size card  -> clicking it clicks the hidden "Add to bag"
       submit button for you (straight add, no panel).
     - multi-size card   -> clicking it opens the sizing panel (adds
       .is-open to the card) so the customer can pick a size. The panel is
       otherwise only shown on hover/focus — never visible at rest.
   Clicking outside an open card, or pressing Escape, closes it again.

   Guarded by a global flag so it stays harmless if the file is ever included
   more than once on a page.
   ========================================================================== */
(function () {
  if (window.__mhCardInit) return;
  window.__mhCardInit = true;

  var FEEDBACK_MS = 2600;

  function setFeedback(form, message) {
    var el = form.querySelector('.mh-card__feedback');
    if (!el) return;
    el.textContent = message || '';
    if (message) {
      window.setTimeout(function () {
        if (el.textContent === message) el.textContent = '';
      }, FEEDBACK_MS);
    }
  }

  function swapSection(html, selector) {
    if (!html) return;
    var current = document.querySelector(selector);
    if (!current) return;
    var parsed = new DOMParser().parseFromString(html, 'text/html');
    var fresh = parsed.querySelector(selector);
    if (fresh) current.innerHTML = fresh.innerHTML;
  }

  function openCartDrawer() {
    var drawer = document.querySelector('cart-drawer');
    if (!drawer) return false;
    drawer.classList.remove('is-empty');
    if (typeof drawer.open === 'function') {
      drawer.open();
      return true;
    }
    return false;
  }

  function closeOpenCards(except) {
    var open = document.querySelectorAll('.mh-card.is-open');
    for (var i = 0; i < open.length; i++) {
      if (open[i] === except) continue;
      open[i].classList.remove('is-open');
      var btn = open[i].querySelector('[data-mh-quick-add]');
      if (btn) btn.setAttribute('aria-expanded', 'false');
    }
  }

  document.addEventListener('click', function (event) {
    var quickAdd = event.target.closest('[data-mh-quick-add]');
    if (quickAdd) {
      var card = quickAdd.closest('.mh-card');
      if (!card) return;

      if (quickAdd.getAttribute('data-multi-size') === 'true') {
        var willOpen = !card.classList.contains('is-open');
        closeOpenCards(willOpen ? card : null);
        card.classList.toggle('is-open', willOpen);
        quickAdd.setAttribute('aria-expanded', willOpen ? 'true' : 'false');
        return;
      }

      var singleAdd = card.querySelector('[data-mh-single-add]');
      if (singleAdd) singleAdd.click();
      return;
    }

    // Click outside any open card closes it.
    if (!event.target.closest('.mh-card.is-open')) {
      closeOpenCards(null);
    }
  });

  document.addEventListener('keydown', function (event) {
    if (event.key === 'Escape') closeOpenCards(null);
  });

  document.addEventListener('submit', function (event) {
    var form = event.target.closest('[data-mh-card-form]');
    if (!form) return;

    var submitter = event.submitter;
    var variantId = submitter && submitter.value;
    if (!variantId) return;

    event.preventDefault();
    if (form.classList.contains('is-loading')) return;
    form.classList.add('is-loading');

    var payload = {
      items: [{ id: Number(variantId), quantity: 1 }],
      sections: ['cart-drawer', 'cart-icon-bubble'],
      sections_url: window.location.pathname
    };

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(payload)
    })
      .then(function (response) {
        return response.json().then(function (data) {
          return { ok: response.ok, data: data };
        });
      })
      .then(function (result) {
        if (!result.ok) {
          setFeedback(form, (result.data && result.data.description) || 'Could not add that item.');
          return;
        }

        var sections = result.data.sections || {};
        swapSection(sections['cart-drawer'], 'cart-drawer');
        swapSection(sections['cart-icon-bubble'], '#cart-icon-bubble');

        var card = form.closest('.mh-card');
        if (card) {
          card.classList.remove('is-open');
          var btn = card.querySelector('[data-mh-quick-add]');
          if (btn) btn.setAttribute('aria-expanded', 'false');
        }

        if (!openCartDrawer()) {
          setFeedback(form, 'Added to bag');
        }
      })
      .catch(function () {
        // Network or parsing problem: fall back to a normal navigation.
        window.location.href = '/cart';
      })
      .finally(function () {
        form.classList.remove('is-loading');
      });
  });
})();
